import { FunctionComponent } from 'react';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import Avatar from './Avatar';
import { formatRemainderNumber } from 'utils';
import { Props } from './MostRecentAvatarTypes';

export const MostRecentAvatars: FunctionComponent<Props> = ({ data }) => {
  const avatars = data
    .slice(0, 3)
    .map((avatar, index) => (
      <Avatar
        key={index}
        src={avatar.src ?? undefined}
        name={avatar.name || ''}
        isRemainder={!avatar.src}
      />
    ));
  let remainderText = '';
  if (data.length > 3) {
    remainderText = formatRemainderNumber(data.length);
    avatars.push(
      <Avatar
        key="remainder"
        name="remainder"
        isRemainder={true}
        displayText={remainderText}
      />,
    );
  }

  return <div css={avatarContainer}>{avatars}</div>;
};

const avatarContainer = css({
  display: 'flex',
  alignItems: 'center',
  marginLeft: token('space.150'),
  '@media (max-width: 420px)': {
    paddingLeft: token('space.150'),
  },
});
